<template>
  <v-container fluid>
    <v-layout column>
      <transition-group tag="div" name="slide-fade">
        <div key="reports1" v-if="!report && !reportV">
          <v-flex
            key="reports-1"
            d-inline-flex 
            align-center 
            class="section-1 general-bg" 
            py-2 
            px-3
          >
            <h2>Reportes</h2>
            
            <v-tabs 
              fixed-tabs
              color="grey darken-4"
              class="px-4 py-2"
              @change="tabChanged"
            >
              <v-tabs-slider color="white"></v-tabs-slider>
              <v-tab href="#tab-1">
                <v-icon left>cloud_download</v-icon>
                Exportable
              </v-tab>

              <v-tab href="#tab-2">
                <v-icon left>my_location</v-icon>
                Visualizador
              </v-tab>
              <v-tab-item value="tab-1">
                <v-flex pt-3>
                  <v-autocomplete
                    v-model="report"
                    label="Elegir exportable"
                    :items="itemsToShow"
                    item-text="name"
                    item-value="value"
                    autocomplete
                  ></v-autocomplete>
                </v-flex>
              </v-tab-item>

              <v-tab-item value="tab-2">
                <v-flex pt-3>
                  <v-autocomplete
                    v-model="reportV"
                    label="Elegir visualizador"
                    :items="itemsV"
                    item-text="name"
                    item-value="value"
                    autocomplete
                  ></v-autocomplete>
                </v-flex>
              </v-tab-item>
            </v-tabs>
          </v-flex>
        </div>

        <div key="reports2" v-else>
          <v-flex
            key="reports-2"
            d-inline-flex 
            align-center 
            class="section-2 general-bg" 
            py-2 
            px-3
          >
            <v-flex>
              <v-btn
                fab
                small
                @click="backToReports"
              >
                <v-icon>arrow_back</v-icon>
              </v-btn>
              Atrás para elegir Reporte
            </v-flex>
          </v-flex>
        </div>
      </transition-group>

      <v-flex v-if="report && activeTab === 'tab-1'" ma-0 pt-3> 
        <!-- TIME REPORT -->
        <report-by-route-time v-if="report === 1"/>

        <!-- POINT REPORT -->
        <report-by-point v-if="report === 2"/>

        <!-- SPEED BY TIME -->
        <report-by-speed-time v-if="report === 3" />

        <!-- SPEED BY VEHICLE -->
        <report-by-speed-vehicle v-if="report === 4" />

        <!-- REPORT LAST EVENT BY VEHICLE -->
        <report-last-event-vehicle v-if="report === 5" />

        <!-- REPORT CURRENT CONDITION VEHICLES -->
        <report-current-condition v-if="report === 6" />

        <!-- REPORT GEOFENCE OUT ALERT TIME -->
        <report-geofence-out-alert-time v-if="report === 7" />

        <!-- REPORT GEOFENCE OUT ALERT VEHICLE -->
        <report-geofence-out-alert-vehicle v-if="report === 8" />

        <!-- REPORT MOVEMENT ALERT TIME -->
        <report-movement-alarms-time v-if="report === 9" />

        <!-- REPORT MOVEMENT ALERT VEHICLE -->
        <report-movement-alarms-vehicle v-if="report === 10" />

        <!-- REPORT PARKING ALERT TIME -->
        <report-parking-alarms-time v-if="report === 11" />

        <!-- REPORT PARKING ALERT VEHICLE -->
        <report-parking-alarms-vehicle v-if="report === 12" />

        <!-- REPORT LOGS HISTORY -->
        <report-logs-history v-if="report === 13" />

        <!-- REPORT GEOFENCE IN ALERT TIME -->
        <report-geofence-in-alert-time v-if="report === 14" />

        <!-- REPORT GEOFENCE IN ALERT VEHICLE -->
        <report-geofence-in-alert-vehicle v-if="report === 15" />
      </v-flex>

      <v-flex v-if="reportV && activeTab === 'tab-2'" ma-0 pt-3>
         <!-- POINT VIEW -->
        <viewer-by-point v-if="reportV === 1"/>
      </v-flex>

      <!-- BIG ICON LOADING -->
      <v-flex 
        v-if="!report && !reportV" 
        class="text-xs-center" 
        pt-5
      >
        <v-avatar
          size="400px"
          color="grey darken-4">
          <v-icon size="280px" color="grey darken-3">table_chart</v-icon>
        </v-avatar>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'

import ReportByRouteTime from './Reports/ReportByRouteTime'
import ReportByPoint from './Reports/ReportByPoint'
import ReportBySpeedTime from './Reports/ReportBySpeedTime'
import ReportBySpeedVehicle from './Reports/ReportBySpeedVehicle'
import ReportLastEventVehicle from './Reports/ReportLastEventVehicle'
import ReportCurrentCondition from './Reports/ReportCurrentCondition'
import ReportGeofenceOutAlertTime from './Reports/ReportGeofenceOutAlertTime'
import ReportGeofenceOutAlertVehicle from './Reports/ReportGeofenceOutAlertVehicle'
import ReportMovementAlarmsTime from './Reports/ReportMovementAlarmsTime'
import ReportMovementAlarmsVehicle from './Reports/ReportMovementAlarmsVehicle'
import ReportParkingAlarmsTime from './Reports/ReportParkingAlarmsTime'
import ReportParkingAlarmsVehicle from './Reports/ReportParkingAlarmsVehicle'
import ReportLogsHistory from './Reports/ReportLogsHistory'
import ReportGeofenceInAlertTime from './Reports/ReportGeofenceInAlertTime'
import ReportGeofenceInAlertVehicle from './Reports/ReportGeofenceInAlertVehicle'

import ViewerByPoint from './Viewers/ViewerByPoint'

import { itemsBase, items, itemsTestEng, itemsTestGO } from '../utils/reportsList'

export default {
  name: 'report-generator',
  components: {
    ViewerByPoint,
    ReportByRouteTime,
    ReportByPoint,
    ReportBySpeedTime,
    ReportBySpeedVehicle,
    ReportLastEventVehicle,
    ReportCurrentCondition,
    ReportGeofenceOutAlertTime,
    ReportGeofenceOutAlertVehicle,
    ReportMovementAlarmsTime,
    ReportMovementAlarmsVehicle,
    ReportParkingAlarmsTime,
    ReportParkingAlarmsVehicle,
    ReportLogsHistory,
    ReportGeofenceInAlertTime,
    ReportGeofenceInAlertVehicle
  },
  data() {
    return {
      activeTab: 'tab-1',
      itemsV: [
        { name: 'Vehículos que pasaron por un punto', value: 1 }
      ],
      reportV: null,
      report: null
    }
  },
  computed: {
    ...mapGetters({
      role: 'auth/role',
      adminRole: 'auth/adminRole',
      opera: 'auth/opera'
    }),
    itemsToShow() {
      let result = itemsBase
      if (this.adminRole === 500) {
        result = itemsTestEng
        return result
      }
      if (this.adminRole === 400) {
        result = itemsTestGO
        return result
      }
      if (this.opera === 0) {
        result = items
        return result
      }
      return result
    }
  },
  methods: {
    backToReports() {
      this.reportV = null
      this.report = null
    },
    tabChanged(tab) {
      this.activeTab = tab
    }
  }
}
 </script>
 
 <style lang="stylus" scoped>
h3
  font-size 30px
  font-weight 500

h4
  font-size 21px
  font-weight 500

.slide-fade-enter-active {
  transition: all .5s ease;
}

.slide-fade-enter {
  transform: translateX(30px);
  opacity: 0;
}

.section-1
  width 480px

.section-2
  width 390px

.general-bg
  background-color #424242
  border-radius 3px
	 
 </style>


// WEBPACK FOOTER //
// src/components/ReportGenerator.vue